'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var Paragraph = require('@narvar/nth-bit-paragraph');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var PackageName = require('../../components/PackageName.js');
var styled = require('styled-components');
var nthBitHeader = require('@narvar/nth-bit-header');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const PackageHeader = styled__default["default"].div.withConfig({
  componentId: "sc-l9q6lu-0"
})(["display:flex;align-items:center;margin-bottom:0.5rem;"]);
const PackageSelectionCardHeader = _ref => {
  let {
    shipment
  } = _ref;
  const {
    claimsShipmentItemsCount
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(PackageHeader, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(PackageName["default"], {
    edd: shipment.edd,
    status: shipment.status,
    statusCode: shipment.statusCode
  })), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    containerCustomStyle: {
      margin: 0
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      margin: '0 0.5rem'
    }
  }, "\u2022"), mustache__default["default"].render(claimsShipmentItemsCount || '', {
    count: shipment.items.length
  })));
};
var PackageSelectionCardHeader$1 = nthHookTranslations.withTranslationsProvider(PackageSelectionCardHeader, {
  translationKeys: ['claimsShipmentItemsCount']
});

exports["default"] = PackageSelectionCardHeader$1;
